var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a", { staticClass: "schedule_link", attrs: { href: _vm.href } }, [
    _c("dl", { staticClass: "box_schedule", style: _vm.style }, [
      _c("dt", [
        _c("span", {
          staticClass: "inner_tit",
          domProps: { innerHTML: _vm._s(_vm.time) }
        })
      ]),
      _vm._v(" "),
      _c("dd", [
        _vm.schedule.image
          ? _c("img", {
              staticClass: "thumb_g",
              attrs: {
                src: _vm.thumbnail,
                width: "45",
                height: "45",
                alt: "썸네일 이미지"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { class: _vm.descClass }, [
          _c("strong", { staticClass: "tit_subject" }, [
            _vm._v(_vm._s(_vm.schedule.title))
          ]),
          _vm._v(" "),
          _c("p", [
            _c("em", [_vm._v(_vm._s(_vm.schedule.category.name))]),
            _vm._v(_vm._s(_vm.schedule.description))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }